module.exports = __webpack_public_path__ + "img/Aura_gold.de507971.png";